// extracted by mini-css-extract-plugin
module.exports = {"page":"interactiveMap_page__x5WY5","page__content":"interactiveMap_page__content__1WEQR"};